import React from 'react'
import { Storage } from "../Storage/Storage"
import { useIdleTimer } from 'react-idle-timer/dist/index.legacy.cjs.js'
// import { Storage } from '../Storage/Storage'
const useDetails = Storage.get('auth')

export const Header = () => {
	function clickevent() {
		document.getElementsByTagName('body')[0].classList.toggle("sidebar-enable");
		document.getElementsByTagName('body')[0].classList.toggle("vertical-collpsed");
	}

	// console.log(useDetails,'useDetails')

	const onIdle = () => {
        Storage.remove('auth')
      }
    
      const { getRemainingTime } = useIdleTimer({
        onIdle,
        timeout: 900_000,
        throttle: 500
      })

	return (
		<header id="page-topbar">
			<div className="navbar-header">
				<div className="d-flex">
					{/* LOGO */}
					<div className="navbar-brand-box">
						<a href="index.html" className="logo logo-dark">
							<span className="logo-sm">
								<img src="/admin/assets/images/logo-sm.png" alt="" height={22} />
							</span>
							<span className="logo-lg">
								<img src="/admin/assets/images/logo_dark.svg" alt="" height={50} />
							</span>
						</a>
						<a href="index.html" className="logo logo-light">
							<span className="logo-sm">
								<img src="/admin/assets/images/logo-sm.png" alt="" height={22} />
							</span>
							<span className="logo-lg">
								<img src="/admin/assets/images/logo-light.png" alt="" height={20} />
							</span>
						</a>
					</div>
					<button
						type="button"
						className="btn btn-sm px-3 font-size-16 header-item"
						onClick={() => clickevent()}
					>

						<i className="fa fa-fw fa-bars" />
					</button>
					{/* App Search*/}
					{/* <form className="app-search d-none d-lg-block">
						<div className="position-relative">
							<input type="text" className="form-control" placeholder="Search..." />
							<span className="uil-search" />
						</div>
					</form> */}
				</div>
				<div className="d-flex">
					<div className="dropdown d-inline-block d-lg-none">
						<button type="button" className="btn header-item noti-icon waves-effect" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i className="uil-search" />
						</button>
						<div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
							<form className="p-3">
								<div className="form-group m-0">
									<div className="input-group">
										<input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
										<div className="input-group-append">
											<button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify" /></button>
										</div>
									</div>
								</div>
							</form>
						</div>

					</div>
					<div className="dropdown d-inline-block">
						<button type="button" className="btn header-item waves-effect" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<img className="rounded-circle header-profile-user" src="/admin/assets/images/users/avatar-4.jpg" alt="Header Avatar" />
							<span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{useDetails?.admin_name || useDetails?.full_name}</span>
							<i className="uil-angle-down d-none d-xl-inline-block font-size-15" />
						</button>
						<div className="dropdown-menu dropdown-menu-end">
							{/* item*/}
							{/* <a className="dropdown-item" href="#"><i className="uil uil-user-circle font-size-18 align-middle text-muted me-1" /> <span className="align-middle">View Profile</span></a> */}
							{/* <a className="dropdown-item" href="#"><i className="uil uil-wallet font-size-18 align-middle me-1 text-muted" /> <span className="align-middle">My Wallet</span></a>
							<a className="dropdown-item d-block" href="#"><i className="uil uil-cog font-size-18 align-middle me-1 text-muted" /> <span className="align-middle">Settings</span> <span className="badge bg-success rounded-pill mt-1 ms-2">03</span></a>
							<a className="dropdown-item" href="#"><i className="uil uil-lock-alt font-size-18 align-middle me-1 text-muted" /> <span className="align-middle">Lock screen</span></a> */}
							<a className="dropdown-item" onClick={() => Storage.remove('auth')}>
								<i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted" />
								<span className="align-middle pointer">Sign out</span></a>
						</div>
					</div>
					{/* <div className="dropdown d-inline-block">
						<button type="button" className="btn header-item noti-icon right-bar-toggle waves-effect">
							<i className="uil-cog" />
						</button>
					</div> */}
				</div>
			</div>
		</header>
	)
}